import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { AudioPlayerComponent } from './audio-player.component';

import { ModalModule } from 'ngx-bootstrap/modal';
import { SharedModule } from "../../app/shared/shared.module";

import { TimeFormatPipe } from './time-format.pipe';

@NgModule({
  declarations: [AudioPlayerComponent, TimeFormatPipe],
  imports: [
    CommonModule,
    TooltipModule.forRoot(),
    ModalModule,
    SharedModule
  ],
  exports: [AudioPlayerComponent]
})

export class AudioPlayerModule { }